import {
    ADDORUPDATEROLE_SUCCESS,
    ADDORUPDATEROLE_FAILED,
    RESET_ADDORUPDATEROLE,
    LOADING_ADDORUPDATEROLE,
    NETWORK_ERROR_ADDORUPDATEROLE,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADDORUPDATEROLE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case ADDORUPDATEROLE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case ADDORUPDATEROLE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_ADDORUPDATEROLE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_ADDORUPDATEROLE:
            return (state = initialState);
        default:
            return state;
    }
};
